import React from 'react';
import {DeleteForeverOutlined} from "@material-ui/icons";

const SidebarNoteItem = ({note, activeNote, setActiveNote, deleteNote}) => {
    return (
        <div className={`app-sidebar-note ${note.id===activeNote ? "active": null}`}
             onClick={()=>setActiveNote(note.id)}>
            <div className="sidebar-note-title">
                <strong>{note.title}</strong>
                <button onClick={()=>deleteNote(note.id)}><DeleteForeverOutlined/></button>
            </div>
            <p>{note.body && note.body.substr(0,35)+"..."}</p>
            <small>Last Modified : {new Date(note.lastModified).toLocaleDateString("en-IN",{
                hour: "2-digit",
                minute: "2-digit"
            })}</small>
        </div>
    );
};

export default SidebarNoteItem;